(ns teamoesterreich.admin-mode.crowdtasker.task.question-detail-form
  (:require [clojure.string :as str]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.eventQuestion :as d-eventQuestion]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.save :refer [save]]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.arrow-upward :refer [arrow-upward]]
            [reagent-material-ui.icons.arrow-downward :refer [arrow-downward]]
            [reagent-material-ui.icons.insert-photo :refer [insert-photo]]
            [reagent-material-ui.icons.radio-button-checked-two-tone :refer [radio-button-checked-two-tone]]
            [reagent-material-ui.icons.check-box-outline-blank-two-tone :refer [check-box-outline-blank-two-tone]]
            [reagent-material-ui.icons.confirmation-number :refer [confirmation-number]]
            [reagent-material-ui.icons.text-fields :refer [text-fields]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))




(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))
(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))


(defn get-base [!question disabled reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!question key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!question key))))
            has-changes? (or
                           (changed? :crowdtaskerQuestion-question )
                           (changed? :crowdtaskerQuestion-questionDynamic)
                           (changed? :crowdtaskerQuestion-description)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            ]
        [mui/card
         (log/debug "rerender form " @!question @!data)
         [mui/card-header {:title "Frage Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    1
            :style      {:margin "0 0 0 0"}
            }

           [mui/grid
            {:container false :item true
             :md 12
             :xs 12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerQuestion-question) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerQuestion-question @!question))
                             :onChange     (fn [e] (change-fn :crowdtaskerQuestion-question (h/event-value e)))
                             :label        "Frage"}]
            ]

           [mui/grid
            {:container false :item true
             :md 12
             :xs 12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerQuestion-description) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (or (:crowdtaskerQuestion-description @!question)))
                             :onChange     (fn [e] (change-fn :crowdtaskerQuestion-description (h/event-value e)))
                             :label        "Frage Beschreibung"}]
            ]




           ]
          [mui/card-actions
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (not has-changes?)
                          :onClick (fn []
                                     (d-eventQuestion/>question-save (:crowdtaskerQuestion-uuid @!question) @!data reload-fn))
                          } "Speichern"])

           ]
          ]

         ]))))

(defn get-header [!question disabled reload-fn]
  [mui/card-header {:onClick reload-fn
                    :title (str "Frage " (:crowdtaskerQuestion-index @!question))}])

(defn get-answerOption-by-index [questions index]
  (first (filter #(= index (js/parseInt (:crowdtaskerAnswerOption-index %))) questions)))

(defn get-max-answer-index [answers]
  (reduce (fn [c e]
            ;(log/debug "answer-index " (:crowdtaskerAnswerOption-index e))
            (max c (js/parseInt (:crowdtaskerAnswerOption-index e)))) 0 (filter (fn [e] (not (false? (:crowdtaskerAnswerOption-active e)))) answers)))

(defn >swap-answerOption-index-upwards [uuid index questions reload-fn]
  (let [index (js/parseInt index)]
    (log/debug ">swap-answerOption-index-upwards" uuid index "lookup " (dec index) (get-answerOption-by-index questions (dec index)))
    (when-let [uuid (:crowdtaskerAnswerOption-uuid  (get-answerOption-by-index questions (dec index)))]
      (d-eventQuestion/>answerOption-save-index uuid index (fn [])))
    (d-eventQuestion/>answerOption-save-index uuid (dec index) reload-fn)))

(defn >swap-answerOption-index-downwards [uuid index questions reload-fn]
  (let [index (js/parseInt index)]
    (log/debug ">swap-answerOption-index-downwards" uuid index  "lookup " (inc index) (get-answerOption-by-index questions (inc index)))
    (when-let [uuid (:crowdtaskerAnswerOption-uuid  (get-answerOption-by-index questions (inc index)))]
      (d-eventQuestion/>answerOption-save-index uuid index (fn [])))
    (d-eventQuestion/>answerOption-save-index uuid (inc index) reload-fn)
    ))

(defn answer-card [answerOption answerOptions reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-answer (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :selected-answer])
        !data (r/cursor !st [:data])
        !del-popup (r/cursor !st [:del-popup])
        ]
    (fn []
      (let [index (js/parseInt (:crowdtaskerAnswerOption-index answerOption))
            edit-mode? (= @!edit-answer (:crowdtaskerAnswerOption-uuid answerOption))
            option-uuid (:crowdtaskerAnswerOption-uuid answerOption)
            option-icon (case (:crowdtaskerAnswerOption-type answerOption)
                          "image" [insert-photo]
                          "radio" [radio-button-checked-two-tone]
                          "checkbox" [check-box-outline-blank-two-tone]
                          "decimal" [confirmation-number]
                          "numeric" [confirmation-number]
                          "text" [text-fields])
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get answerOption key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get answerOption key))))
            has-changes? (or
                           (changed? :crowdtaskerAnswerOption-points)
                           (changed? :crowdtaskerAnswerOption-type)
                           (changed? :crowdtaskerAnswerOption-text)
                           (changed? :crowdtaskerAnswerOption-hint)
                           (changed? :crowdtaskerAnswerOption-motiv)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))]
        (if-not edit-mode?
          [mui/card {:style {:marginBottom "5px"}}

           [are-you-sure-modal/are-you-sure-modal !del-popup "Bist du sicher, dass du diese Antwort löschen möchtest?" "Löschen"
            #(d-eventQuestion/>answerOption-save option-uuid {:crowdtaskerAnswerOption-active false} reload-fn)]

           [mui/card-header {:subheader (str "Antwortoption " index)}]
           [mui/card-content option-icon [:span {:style {:display "inline_block" :verticalAlign "center" :fontSize "18px" :marginLeft "10px"}} (:crowdtaskerAnswerOption-text answerOption)]
            ]
           [mui/card-actions
            [mui/button{:startIcon (r/as-element [edit])
                        :onClick #(reset! !edit-answer option-uuid)} "Bearbeiten"]
            [mui/button {:startIcon (r/as-element [delete-forever])
                         :onClick   #(reset! !del-popup true)}
             "Löschen"]
            (when (> index 1)
              [mui/icon-button {:onClick #(>swap-answerOption-index-upwards option-uuid index answerOptions reload-fn)
                                } [arrow-upward]])
            (when (< index (get-max-answer-index answerOptions))
              [mui/icon-button {:onClick #(>swap-answerOption-index-downwards option-uuid index answerOptions reload-fn)
                                } [arrow-downward]])

            ;[:span index " / " (get-max-answer-index answerOptions)]
            ]]
          ;edit mode
          [mui/card {:style {:marginBottom "5px" }}

           [mui/card-header {:subheader (str "Antwortoption ")}]
           [mui/card-content
            [mui/grid {:container true :direction  "row" :justify "flex-start" :alignItems "flex-start" :spacing 3}

             [mui/grid {:container false :item true :md 12 :xs 12}
              [mui/select
               {:style {:backgroundColor (if (changed? :crowdtaskerAnswerOption-type) "#ffd6d2" "#ffffff") :width "300px"}
                :value (or (:crowdtaskerAnswerOption-type @!data) (:crowdtaskerAnswerOption-type answerOption))
                :onChange (fn [e] (change-fn :crowdtaskerAnswerOption-type (h/event-value e)))
                :label "Antwort Option Typ"}
               [mui/menu-item {:value "image" :key "image"} "Bild"]
               [mui/menu-item {:value "radio" :key "radio"} "Einfach-Auswahl"]
               [mui/menu-item {:value "checkbox" :key "checkbox"} "Multi-Auswahl"]
               [mui/menu-item {:value "decimal" :key "decimal"} "Dezimalzahl"]
               [mui/menu-item {:value "numeric" :key "numeric"} "Ganzahl"]
               [mui/menu-item {:value "text" :key "text"} "Text"]
               ]]

             (when (some #(= % (:crowdtaskerAnswerOption-type answerOption)) ["checkbox" "radioOption"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :crowdtaskerAnswerOption-text) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:crowdtaskerAnswerOption-text answerOption))
                                 :onChange     (fn [e] (change-fn :crowdtaskerAnswerOption-text (h/event-value e)))
                                 :label        "Antwort Text"}]])


             (when (some #(= % (:crowdtaskerAnswerOption-type answerOption)) ["text" "decimal" "number" "image"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :crowdtaskerAnswerOption-hint) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:crowdtaskerAnswerOption-hint answerOption))
                                 :onChange     (fn [e] (change-fn :crowdtaskerAnswerOption-hint (h/event-value e)))
                                 :label        "Hinweis"}]])

             (when (some #(= % (:crowdtaskerAnswerOption-type answerOption)) ["radioOption"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :crowdtaskerAnswerOption-radio-group-name) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:crowdtaskerAnswerOption-radio-group-name answerOption))
                                 :onChange     (fn [e] (change-fn :crowdtaskerAnswerOption-radio-group-name (h/event-value e)))
                                 :label        "Radio-Gruppe"}]])


             ]
            ]
           [mui/card-actions
            [mui/button{:startIcon (r/as-element [keyboard-arrow-left])
                        :onClick #(reset! !edit-answer nil)} "Abbrechen"]
            (when has-changes? [mui/button {:startIcon (r/as-element [save])
                                            :color     "primary"
                                            :onClick   #(d-eventQuestion/>answerOption-save option-uuid @!data reload-fn)}
                                "Speichern"])
            ]]



          )))))

(defn get-answers [!question disabled reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !addOptionPopupShow (r/cursor !st [:addOptionPopupShow])
        ]
    (fn []
      [mui/card-content
       [create-with-name-modal/modal !addOptionPopupShow
        (str "Bitte gib einen Namen für die neue Antwort Option ein " )
        "Anlegen"
        (fn [name]
          (log/debug "Create with Name: " @!question name)
          (d-eventQuestion/>answerOption-add-new (:crowdtaskerQuestion-uuid @!question) name (inc (get-max-answer-index (:crowdtaskerQuestion-answerOption @!question))) reload-fn)
          )
        ]
       (doall (for [answerOption (sort-by #(js/parseInt (:crowdtaskerAnswerOption-index %)) (set (filter (fn [e]
                                                                                                           (and
                                                                                                             (not (false? (:crowdtaskerAnswerOption-active e)))
                                                                                                             (not= (:crowdtaskerAnswerOption-type e) "radioOption")))
                                                                                                       (clojure.walk/keywordize-keys (:crowdtaskerQuestion-answerOption @!question)))))]
                ^{:key (str "answerOption-" (:crowdtaskerAnswerOption-uuid answerOption))}
                [(answer-card answerOption (:crowdtaskerQuestion-answerOption @!question) reload-fn)]))
       [mui/card-actions
        [mui/button {:startIcon (r/as-element [add])
                     :onClick #(reset! !addOptionPopupShow true)}
         "Neue Antwort hinzufügen"]]
       ])))

(defn question-form [!open-question reload-fn]
  (let [!question (r/cursor vstate/app-state [:edit-crowdtaskerQuestion :questions @!open-question])]
    [mui/card {:style {:maxWidth "1400px"}}
     [mui/card-actions
      [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                   :onClick #(reset! !open-question nil)} "Zurück"]
      [mui/button {:startIcon (r/as-element [refresh])
                   :onClick reload-fn} "Neu laden"]]

     [get-header !question false reload-fn]
     (log/debug "!question" @!question)
     [mui/card {:style {}}

      [get-base !question false reload-fn]

      [mui/divider]
      [(get-answers !question false reload-fn)]
      ]
     [mui/card-actions
      [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                   :onClick #(reset! !open-question nil)} "Zurück"]]


     ]))